import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IhmAutocompleteHighlightPipe } from './../../shared/pipes/ihm-autocomplete-highlight.pipe';
import { IhmWarningIconPipe } from './../../shared/pipes/ihm-warning-icon/ihm-warning-icon.pipe';
import { IhmSystemStatusPipe } from './ihm-system-status-view/ihm-system-status.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [IhmAutocompleteHighlightPipe, IhmWarningIconPipe, IhmSystemStatusPipe],
  exports: [IhmAutocompleteHighlightPipe, IhmWarningIconPipe, IhmSystemStatusPipe]
})
export class IhmPipesModule {}
